/* eslint-disable no-unused-vars */
import { getEvent, getCheckIn, salesByTicketDash } from "@/api";
import { rest } from "lodash";
import sales from "./sales";

const state = {
  isOpenModal: false,
  dashEvent: {},
  dashEventReport: {},
  checkinEvent: {},
  dashEventLoading: false,
  dashboardPDFLoading: false,
  dashboardCSVLoading: false,
  resumeLoading: false,
  dashLoading: false,
  showDetails: false,
  salesByTicketDashLoading: false,
  tickets: {},

  idproduto: "",
  descproduto: "",
};

const getters = {
  allTickets: state => state.tickets,
  salesByTicketDashLoading: state => state.salesByTicketDashLoading,
  isOpenModal: state => state.isOpenModal,
  showDetails: state => state.showDetails,
  dashEvent: state => state.dashEvent,
  checkinEvent: state => state.checkinEvent,
  dashEventReport: state => state.dashEventReport,
  dashLoading: state => state.dashLoading,
  dashEventLoading: state => state.dashEventLoading,
  dashboardPDFLoading: state => state.dashboardPDFLoading,
  dashboardCSVLoading: state => state.dashboardCSVLoading,
  dashEventHasData: state => Object.keys(state.dashEvent).length > 0,

  idProduto: state => state.idproduto,
  descProduto: state => state.descproduto,
};

const exportData = async (
  commit,
  apiFunction,
  fileType,
  reportName,
  params
) => {
  commit(`setDashboard${fileType.toUpperCase()}Loading`, true);
  const exportType = fileType;
  const type = fileType === "csv" ? "text/csv" : "application/pdf";

  try {
    const { idproduto, ...rest } = params;
    const response = await apiFunction(idproduto, rest, exportType);
    const file = new Blob([response.data], { type });
    const fileURL = URL.createObjectURL(file);
    if (fileType === "csv") {
      const a = document.createElement("a");
      document.body.appendChild(a);
      a.style = "display: none";
      a.href = fileURL;
      a.download = `Relatório ${reportName}`;
      a.click();
      window.URL.revokeObjectURL(fileURL);
    } else window.open(fileURL);
  } catch (error) {
    console.error(`Erro ao exportar dados: ${error.message}`);
  } finally {
    commit(`setDashboard${fileType.toUpperCase()}Loading`, false);
  }
};

const mutations = {
  setIsOpenModal(state, bool) {
    state.isOpenModal = bool;
  },
  isShowDetails(state, showDetails) {
    state.showDetails = showDetails;
  },
  setDashReport(state, dashEventReport) {
    state.dashEventReport = dashEventReport;
  },
  setDashEvent(state, dashEvent) {
    state.dashEvent = dashEvent || "";
    state.isOpenModal = true;
    state.dashEventLoading = true;
    state.dashLoading = true;
  },
  setDashResume(state, dashEvent) {
    state.dashEvent = dashEvent;
  },
  setDashEventLoading(state, loading) {
    state.dashEventLoading = loading;
  },
  setSalesByTicketDashLoading(state, salesByTicketDashLoading) {
    state.salesByTicketDashLoading = salesByTicketDashLoading;
  },
  setDashboardPDFLoading(state, dashboardPDFLoading) {
    state.dashboardPDFLoading = dashboardPDFLoading;
  },
  setDashboardCSVLoading(state, dashboardCSVLoading) {
    state.dashboardCSVLoading = dashboardCSVLoading;
  },
  setDashCheckin(state, checkinEvent) {
    state.checkinEvent = checkinEvent;
  },
  setTicketsReport(state, tickets) {
    state.tickets = tickets;
  },
  setIdProduto(state, idproduto) {
    state.idproduto = idproduto;
  },
  setDescProduto(state, descproduto) {
    state.descproduto = descproduto;
  },
};

const actions = {
  async exportTicketCSV({ commit }, params) {
    await exportData(
      commit,
      salesByTicketDash,
      "csv",
      "Vendas por Evento",
      params
    );
  },
  async exportTicketPDF({ commit }, params) {
    await exportData(
      commit,
      salesByTicketDash,
      "pdf",
      "Vendas por Evento",
      params
    );
  },
  fetchTicketsReport({ commit }, tickets) {
    commit("setSalesByTicketDashLoading", true);
    salesByTicketDash(tickets.idproduto, tickets.filtros).then(response => {
      commit("setTicketsReport", response.data);
      commit("setSalesByTicketDashLoading", false);
    });
  },
  setShowDetails({ commit }) {
    commit("isShowDetails", true);
  },
  openModal({ commit }) {
    commit("setIsOpenModal", true);
  },
  async getDashEvent({ commit, dispatch }, dashEvent) {
    commit("setDashEventLoading", true);

    await getEvent(dashEvent.idproduto).then(res => {
      const response = res.data;
      commit("setDashEvent", {
        ...dashEvent,
        ...response,
      });
      commit("setDashEventLoading", "dashLoading", false);
      dispatch("getDashCheckin", dashEvent);
    });
  },

  getDashCheckin({ commit }, checkinEvent) {
    commit("setDashEventLoading", true);
    getCheckIn(checkinEvent.idproduto).then(res => {
      const response = res.data;
      commit("setDashCheckin", {
        ...checkinEvent,
        ...response,
      });
      commit("setDashEventLoading", false);
    });
  },
};

export default {
  state,
  getters,
  mutations,
  actions,
};
